import { render, staticRenderFns } from "./PersonalHistoryPhase.vue?vue&type=template&id=5871d154&scoped=true&"
import script from "./PersonalHistoryPhase.vue?vue&type=script&lang=js&"
export * from "./PersonalHistoryPhase.vue?vue&type=script&lang=js&"
import style0 from "./PersonalHistoryPhase.vue?vue&type=style&index=0&id=5871d154&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871d154",
  null
  
)

export default component.exports